"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Floor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_cirrus_store_1 = require("@yanzi/react-cirrus-store");
const lodash_1 = require("lodash");
const react_1 = require("react");
const Layer_1 = require("./Layer");
function Floor(_a) {
    var { baseUrl, floorLevel, layerFilter } = _a, props = __rest(_a, ["baseUrl", "floorLevel", "layerFilter"]);
    const { data: manifest } = react_cirrus_store_1.useCirrusStoreGet(`${baseUrl}/manifest.json`);
    const floorLayers = react_1.useMemo(() => {
        if (!manifest)
            return [];
        return lodash_1.orderBy(manifest.layers.filter(layer => `${layer.floorLevel}` === `${floorLevel}` || `${layer.floor}` === `${floorLevel}`), [x => x.zIndex], ['asc']);
    }, [manifest, floorLevel]);
    const finalLayers = react_1.useMemo(() => {
        return floorLayers.filter(layer => { var _a; return (_a = layerFilter === null || layerFilter === void 0 ? void 0 : layerFilter(layer)) !== null && _a !== void 0 ? _a : true; });
    }, [floorLayers, layerFilter]);
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: finalLayers.map((layer, i) => {
            var _a;
            return (jsx_runtime_1.jsx(Layer_1.Layer, Object.assign({ layer: layer, baseUrl: baseUrl }, props, { zIndex: ((_a = props.zIndex) !== null && _a !== void 0 ? _a : 0) + i }), layer.id));
        }) }, void 0));
}
exports.Floor = Floor;
exports.default = Floor;
//# sourceMappingURL=Floor.js.map